import { Attractor } from "./Attractor";
export async function loadExternalAttractInteraction(engine, refresh = true) {
    await engine.addInteractor("externalAttract", (container) => new Attractor(engine, container), refresh);
}
export * from "./Options/Classes/Attract";
export * from "./Options/Interfaces/IAttract";
